import { ChartContainer } from '../../shared/ChartContainer';
import { EmptyState } from '../../shared/EmptyState';
import type { FpUnmetDemandRow } from '../../../../types/analytics.types';

type UnmetDemandCardsProps = {
  regions: FpUnmetDemandRow[];
};

const TITLE = 'Unmet Demand Regions';
const SUBTITLE = 'Where searches returned no providers — recruitment signal';

export const UnmetDemandCards = ({ regions }: UnmetDemandCardsProps) => {
  if (regions.length === 0) {
    return (
      <ChartContainer title={TITLE} subtitle={SUBTITLE}>
        <EmptyState message="No zero-result searches for the selected filters." />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer title={TITLE} subtitle={SUBTITLE}>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {regions.map((r) => (
          <div
            key={r.stateCode}
            className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3"
          >
            <div className="flex items-baseline justify-between">
              <span className="text-sm font-semibold text-gray-900">{r.stateCode}</span>
              <span className="text-lg font-bold text-amber-700">
                {r.zeroResultSearches.toLocaleString('en-US')}
              </span>
            </div>
            <p className="mt-1 text-xs text-gray-500">
              zero-result searches
              {r.topCategory ? ` · ${r.topCategory}` : ''}
            </p>
          </div>
        ))}
      </div>
    </ChartContainer>
  );
};
